import { render, staticRenderFns } from "./UserManageModal.vue?vue&type=template&id=8b4c4020&"
import script from "./UserManageModal.vue?vue&type=script&lang=js&"
export * from "./UserManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserManageModal.vue"
export default component.exports